import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { PipePipes } from './pipe.pipes';
import { PublicLabelPipe } from './pipes/public-label.pipe';

@NgModule({
  imports: [CommonModule],
  exports: [...PipePipes],
  declarations: [...PipePipes, PublicLabelPipe],
  providers: [DatePipe, DecimalPipe],
})
export class CustomPipesModule {
  static forRoot(): ModuleWithProviders<CustomPipesModule> {
    return {
      ngModule: CustomPipesModule,
      providers: [],
    };
  }
}
